/**
 * Created by richardlovejoy on 2/16/17.
 */

import NumberDisplay from './NumberDisplay';
import Phaser from 'phaser';

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const FrontBallMeter = function(game) {

  Phaser.Group.call(this, game);
  this.name = 'FrontBallMeter';

  this.init();
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
FrontBallMeter.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: FrontBallMeter,


  init() {
    // balls
    this.ballsMeter = Object.create(NumberDisplay).init(this.game, this, 693, 383, 2, 0.348, {
      hideLeadingZeroes: true,
      showDigitBack: true
    });

    this.ballsMeter.setValue(this.game.logic.ballsLeft);

    // listen for balls left changes
    this.game.logic.onSignalBallsLeftChanged.add(ballsLeft => {

      // update balls meter
      this.ballsMeter.setValue(ballsLeft);

    });

    return this;
  },

  frameUpdate(dt) {

    this.scoreMeter.frameUpdate(dt);
  }
});

export default FrontBallMeter;



// WEBPACK FOOTER //
// ./app/src/display/meters/FrontBallMeter.js